import { gql } from '@apollo/client'

export const SEND_BROADSIGN_CREATION_TO_ACCEPTANCE = gql`
  mutation SendBroadsignCreationToAcceptance($id: ID!) {
    sendBroadsignCreationToAcceptance(input: { id: $id }) {
      broadsignCreationBuildings {
        id
        buildingId
        acceptanceStatus
        used
      }
      errors
      success
    }
  }
`
